// @flow
import React from 'react';
import './OrderSearch.scss';

type Props = {
  searchTerm: string,
  onSearchInputChange: (searchTerm: string) => void,
  onSearchSubmit: () => void,
  isSearching: boolean,
};

const OrderSearch = (props: Props) => {
  const handleInputChange = e => {
    props.onSearchInputChange(e.target.value);
  };

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      props.onSearchSubmit();
    }
  };

  const handleSearchClick = () => {
    props.onSearchSubmit();
  };

  const handleClearClick = () => {
    props.onSearchInputChange('');
    // 빈 문자열로 검색 실행 (검색 초기화)
    props.onSearchSubmit('');
  };

  return (
    <div className="OrderSearch">
      <div className="search-container">
        <div className="search-main-container">
          <div className="search-input-wrapper">
            <input
              type="text"
              className="search-input"
              placeholder="주문번호, 상품명, 카탈로그번호를 입력하세요"
              value={props.searchTerm}
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
              disabled={props.isSearching}
            />
            {props.searchTerm && (
              <button
                type="button"
                className="clear-button"
                onClick={handleClearClick}
                disabled={props.isSearching}
                aria-label="검색어 지우기"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            )}
          </div>

          <div className="search-button-group">
            <button
              type="button"
              className="reset-button"
              onClick={handleClearClick}
              disabled={props.isSearching}
              aria-label="검색 초기화"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <polyline points="23 4 23 10 17 10"></polyline>
                <polyline points="1 20 1 14 7 14"></polyline>
                <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>
              </svg>
              <span className="button-text">초기화</span>
            </button>

            <button
              type="button"
              className="search-button"
              onClick={handleSearchClick}
              disabled={props.isSearching || !props.searchTerm.trim()}
            >
              {props.isSearching ? (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <circle cx="12" cy="12" r="3"></circle>
                  <path d="M12 1v6M12 17v6M4.22 4.22l4.24 4.24M15.54 15.54l4.24 4.24M1 12h6M17 12h6M4.22 19.78l4.24-4.24M15.54 8.46l4.24-4.24"></path>
                </svg>
              ) : (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="M21 21l-4.35-4.35"></path>
                </svg>
              )}
              <span className="button-text">{props.isSearching ? '검색 중...' : '검색'}</span>
            </button>
          </div>
        </div>

        {/* {props.searchTerm && (
          <div className="search-info">
            <span className="search-term-label">검색어:</span>
            <span className="search-term-value">&ldquo;{props.searchTerm}&rdquo;</span>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default OrderSearch;



// WEBPACK FOOTER //
// ./src/components/order/OrderListTemplate/OrderSearch.js